import { MasterConfigContext } from "@/context/MasterConfigContext";
import useIsMobile from "@/hooks/useIsMobile";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import StripeStatus from "../Symbals";
import { useRouter } from "next/router";

// import "./index.css";

const RegionalsElectionResultsComponent = ({
  electionPassedCategory = "",
  masterKey = "",
  constituencyListData = {},
  stateHindi = "",
}) => {
  const [winnersData, setWinnersData] = useState(
    constituencyListData?.seat_data
  );
  const [prevData, setPrevData] = useState(constituencyListData?.seat_data);
  // const [searchParams, setSearchParams] = useSearchParams();
  const { regional } = useParams();
  const masterConfig = useContext(MasterConfigContext);
  const electionKeys = masterConfig[masterKey];

  const showCandidatePrfile = electionKeys?.herSeatCandiInterLink;
  const isMobile = useIsMobile();
  const redirectUrl = {
    up: "https://www.uptak.in",
    mp: "https://www.mptak.in/elections",
    ch: "https://www.chhattisgarhtak.in/elections",
    rj: "https://www.rajasthantak.com/elections",
    gj: "https://www.gujarattak.in/elections",
    mt: "https://mumbaitak.in",
  };
  const stateId = {
    up: "S24",
    mp: "S12",
    ch: "S26",
    rj: "S20",
    gj: "S06",
    mt: "S13",
  };
  const apiStateName = {
    up: "uttar-pradesh",
    mp: "madhya-pradesh",
    cg: "chhattisgarh",
    rj: "rajasthan",
    gj: "gujarat",
    mt: "maharashtra",
  };

  const options = [
    {
      value: 0,
      label: "2019",
    },
    // {
    //   value: 2,
    //   label: '2024'
    // }
  ];
  const colorOptions = {
    llt: "#eb0e8c",
    tg: "#d9368b",
    mz: "#8ab3dc",
    mp: "#0c8a70",
    cg: "#2d8468",
    llt: "#d9368b",
    rj: "#fed029",
    up: "#f6523e",
    gj: "#f362b3",
    ct: "#B71F33",
    mt: "#f92929",
  };
  const router = useRouter();



  const isBihar = router?.asPath?.includes("bihar");
  const isAssam =electionKeys?.isAssamConstituencyListNotClick
  //  router?.asPath?.includes("assam/constituency-list") && electionKeys?.constListYear == 2021;

  const isFiveStates = ["west-bengal", "assam", "tamil-nadu", "puducherry", "kerala"].some((state) => router?.asPath?.includes(state));
  const isHaryana = router?.asPath.includes("haryana");
  const getWinnersList = async () => {
    try {
      const response = await fetch(`${electionKeys.allConstituency2021Api ||electionKeys.allConstituency2020Api}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data1 = await response.json();
      let tempData = data1?.seat_data;

      if (tempData?.length > 0) {
        setWinnersData(tempData);
        setPrevData(tempData);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const getWinnersList2 = async () => {
    try {
      const response = await fetch(
        `${electionKeys.allConstituency2026Api ||electionKeys.allConstituency2025Api ||
        electionKeys.allConstituency2024Api
        }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data1 = await response.json();
      let tempData = data1?.data?.seat_data;

      if (tempData?.length > 0) {
        setWinnersData(tempData);
        setPrevData(tempData);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  useEffect(() => {
    if (
      electionKeys?.constListYear === 2026 || electionKeys?.constListYear === 2025 ||
      electionKeys?.resultYear === 2024
    ) {
      getWinnersList2();
      const interval = setInterval(() => {
        getWinnersList2();
      }, 30000);

      // console.log("Polling started");

      return () => clearInterval(interval);
    } else {
      getWinnersList();
    }
  }, []);

  function findSearchData(value) {
    const normalizeText = (txt = "") =>
      txt
        .toString()
        .toLowerCase()
        .normalize("NFC")
        .replace(/[\u0900-\u097F]/g, (ch) =>
          ch.normalize("NFD").replace(/[\u093C\u094D]/g, "")
        )
        .trim();

    const query = normalizeText(value);

    const filtered = constituencyListData?.seat_data?.filter((item) => {
      const acName = normalizeText(item?.ac_name);
      const seatName = normalizeText(item?.seat_name_h);
      const candidate = normalizeText(item?.candidate_name);
      const candidateH = normalizeText(item?.candidate_name_h);
      const constituency = normalizeText(item?.constitutency_hi);

      return (
        acName.includes(query) ||
        seatName.includes(query) ||
        candidate.includes(query) ||
        candidateH.includes(query) ||
        constituency.includes(query)
      );
    });

    setPrevData(filtered || []);
  }

  function findSearchData2024(value) {
    const normalizeText = (txt) =>
      txt
        ?.toLowerCase()
        ?.normalize("NFC")
        ?.replace(/[\u0900-\u097F]/g, (ch) =>
          ch.normalize("NFD").replace(/[\u093C\u094D]/g, "")
        )
        ?.trim();

    const query = normalizeText(value);
    setPrevData(
      winnersData.filter(
        (item) =>
          normalizeText(item.seat_name).includes(query) ||
          normalizeText(item.seat_name_h).includes(query) ||
          normalizeText(item.candidate_name).includes(query) ||
          normalizeText(item.candidate_name_h).includes(query) ||
          normalizeText(item.constitutency_hi).includes(query)
      )
    );
  }


  return (
    <>
      <div className="result-page mx-2">
        {/* <div>
        <h1>
          Lok Sabha Election 2019 Constituency Wise Winning Candidates List
        </h1>
      </div> */}
        <div className="tp-data">
          {/* <div className="tp-select">
          <ul>
            <li className="lead">
              Lead
              <img
                alt="lead"
                src="https://akm-img-a-in.tosshub.com/sites/electiontak/images/app-up-arrow.png"
              />
            </li>
            <li className="won">
              Won
              <img
                alt="won"
                height="16px"
                src="https://akm-img-a-in.tosshub.com/sites/electiontak/images/won.png"
              />
            </li>
          </ul>
        </div> */}
        </div>
        <div className="winners-list-box">
          <div className="flex flex-col sm:flex-row items-start md:items-center justify-between w-full">
            <h2 className="text-lg sm:text-xl font-bold text-center sm:text-left">
             {stateHindi} विधानसभा चुनाव <span className="text-bold md:text-[22px]">{electionKeys?.constListYear} </span> 
            </h2>

            {/* <div className=" sm:mt-0"> */}
            <StripeStatus />
            {/* </div> */}
          </div>

          <div>
            {/* <br></br> */}
            <div className="search_cont snipcss0-0-0-1 snipcss-rNdJP">
              {" "}
              <input
                type="text"
                id="winner_list"
                placeholder="Search for names.."
                title="Type in a name"
                autoComplete="off"
                className="snipcss0-1-1-2"
                onChange={(e) => {
                  if (electionKeys?.constListYear === 2026 || electionKeys?.constListYear === 2025) {
                    findSearchData2024(e.target.value);
                  } else {
                    findSearchData(e.target.value);
                  }
                }}
              />{" "}
            </div>
          </div>
          {/* <br></br> */}
          <div>
            <table>
              <th
                style={{
                  backgroundColor: isBihar
                    ? colorOptions[regional]
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436",
                }}
              >
                निर्वाचन क्षेत्र
              </th>
              <th
                style={{
                  backgroundColor: isBihar
                    ? colorOptions[regional]
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436",
                }}
              >
                पार्टी
              </th>
              <th
                style={{
                  backgroundColor: isBihar
                    ? colorOptions[regional]
                    : isHaryana
                      ? "#64BC46"
                      : "#EE3436",
                }}
              >
                विजेता
              </th>
              {[2020, 2021].includes(Number(electionKeys?.constListYear)) &&
                prevData?.length > 0 &&
                prevData.map((con, index) => {
                  return (
                    <tr
                      className={index % 2 !== 0 ? "oddColor" : ""}
                      key={index}
                    >
                      <td
                        style={{
                          textAlign: "center",
                          cursor: isAssam ? "":"pointer",
                          textDecoration:isAssam ? "": "underline",
                        }}
                      >
                        {isAssam? <span className="text-align-left">
                          {con?.constitutency_hi || con?.cons_name || con?.seat_name_h}
                        </span>:<a
                          className="text-align-left hover:text-primary underline"
                          href={
                            (isBihar || isFiveStates)
                              ? `${process?.env?.NEXT_PUBLIC_WEBSITE_URL}/elections/${electionPassedCategory}/${con?.ac_name
                                ?.toLowerCase()
                                .replace(/[^a-zA-Z ]/g, "")
                                .split(" ")
                                .join("-")}-assembly-constituency-result-${con?.ac_no}`
                              : `${process?.env?.NEXT_PUBLIC_WEBSITE_URL}/elections/${electionPassedCategory}/constituencies/${con?.ac_name
                                ?.toLowerCase()
                                .replace(/[^a-zA-Z ]/g, "")
                                .split(" ")
                                .join("-")}-constituency-result-${con?.ac_no}`
                          }
                        >
                          {con?.constitutency_hi || con?.cons_name || con?.seat_name_h}
                        </a>}
                      </td>


                      <td className="text-center whitespace-nowrap">
                        <div className="flex flex-col items-center md:flex-row md:justify-center">

                          <img
                            src={con?.party_logo}
                            className="h-6 w-6 rounded-full mb-1 md:mb-0 md:mr-2"
                            alt="party"
                          />

                          <span>{con?.party}</span>

                        </div>
                      </td>

                      {/* Candidate */}
                      <td className="text-center">
                        {showCandidatePrfile ? (
                          con?.candidate_name === "Result Awaited" ? (
                            <div className="mx-6">
                              {con?.candidate_name?.replace(/&apos;/g, "") ||
                                con?.name?.replace(/&apos;/g, "")}
                            </div>
                          ) : (
                            <a
                              className="hover:text-primary underline"
                              href={`${process?.env?.NEXT_PUBLIC_WEBSITE_URL}/elections/${electionPassedCategory}/candidates/${con?.candidate_name || con?.name
                                ?.toLowerCase()
                                .replace(/[^a-zA-Z ]/g, "")
                                .split(" ")
                                .join("-")}-result-${con?.seat_name || con?.ac_name
                                  ?.toLowerCase()
                                  .replace(/[^a-zA-Z ]/g, "")
                                  .split(" ")
                                  .join("-")}-${con?.id}-${con?.candidate_id || index + 1}`}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  justifyContent: isMobile ? "flex-start" : "center",
                                  flexDirection: isMobile ? "column" : "row",
                                  alignItems: "center",
                                }}
                              >
                                {con?.status === "LEADING" && (
                                  <img
                                    src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/up-arrow.png"
                                    width="20"
                                    height="20"
                                  />
                                )}

                                {con?.name === "Result Awaited"
                                  ? "-"
                                  : con?.name?.replace(/&apos;/g, "")}
                              </div>
                            </a>
                          )
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              gap: "5px",
                              justifyContent: isMobile ? "flex-start" : "center",
                              flexDirection: isMobile ? "column" : "row",
                              alignItems: "center",
                            }}
                          >
                            {con?.name === "Result Awaited"
                              ? "-"
                              : con?.name?.replace(/&apos;/g, "")}
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              {(electionKeys?.constListYear === 2026 || electionKeys?.constListYear === 2025 || electionKeys?.constListYear === 2024) &&
                prevData &&
                prevData?.map((con, index) => {
                  return (
                    <tr
                      className={index % 2 !== 0 ? "oddColor" : ""}
                      key={index}
                    >
                      <td
                        style={{
                          textAlign: "center",
                           cursor: isAssam ? "":"pointer",
                          textDecoration:isAssam ? "": "underline",
                        }}
                      >
                      { isAssam? <span className="text-align-left">
                          {con?.constitutency_hi || con?.cons_name || con?.seat_name_h}
                        </span>: <a
                          className={
                            isBihar
                              ? ` hover:#EE3436`
                              : isHaryana
                                ? ` hover:text-hrDark`
                                : ` hover:text-primary underline`
                          }
                          href={
                            (isBihar || isFiveStates)
                              ? `${process?.env?.NEXT_PUBLIC_WEBSITE_URL
                              }/elections/${electionPassedCategory}/${(
                                con?.seat_name ||
                                con?.seat_name_h ||
                                con?.ac_name
                              )

                                ?.toLowerCase()
                                .replace(/[^a-zA-Z ]/g, "")
                                .split(" ")
                                .join("-")}-assembly-constituency-result-${con?.seat_number || con?.id
                              }`
                              : ` ${process?.env?.NEXT_PUBLIC_WEBSITE_URL
                              }/elections/${electionPassedCategory}/constituencies/${(
                                con?.seat_name ||
                                con?.seat_name_h ||
                                con?.ac_name
                              )

                                ?.toLowerCase()
                                .replace(/[^a-zA-Z ]/g, "")
                                .split(" ")
                                .join("-")}-constituency-result-${con?.seat_number || con?.id
                              }`
                          }
                        >
                          {con?.seat_name_h || con?.constitutency_hi}
                        </a>}
                      </td>
                      <td
                        className={` ${isMobile
                          ? "justify-items-center  text-center "
                          : "  flex justify-center align-center whitespace-nowrap "
                          } `}
                      //  className="whitespace-nowrap"
                      >
                        <img
                          src={con?.party_logo}
                          style={{
                            height: "24px",
                            width: "24px",
                            borderRadius: "100%",
                          }}
                        ></img>
                        <span className="mx-0 md:mx-2">
                          {con?.party_name || con?.party}
                        </span>
                      </td>
                      <td className="  font-[16px]  justify-center align-center text-center">
                        {showCandidatePrfile ? (
                          con?.candidate_name == "Result Awaited" ? (
                            <div className="mx-6">
                              {con?.candidate_name?.replace(/&apos;/g, "") ||
                                con?.name.replace(/&apos;/g, "")}
                            </div>
                          ) : (
                            <a
                              className={`   hover:text-primary underline`}
                              href={
                                con?.candidate_name == "Result Awaited"
                                  ? ""
                                  : `${process?.env?.NEXT_PUBLIC_WEBSITE_URL
                                  }/elections/${electionPassedCategory}/candidates/${(
                                    con?.candidate_name || con?.name
                                  )

                                    ?.toLowerCase()
                                    .replace(/[^a-zA-Z ]/g, "")
                                    .split(" ")
                                    .join("-")}-result-${(
                                      con?.seat_name || con?.seat_name_h
                                    )
                                      ?.toLowerCase()
                                      .replace(/[^a-zA-Z ]/g, "")
                                      .split(" ")
                                      .join("-")}-${con?.id}-${con?.candidate_id
                                  }` //by default candidate id
                              }
                            >
                              <div
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  justifyContent: isMobile
                                    ? "flex-start "
                                    : "center",
                                  flexDirection: isMobile ? "column" : "row",
                                  alignItems: "center",
                                  // paddingLeft: isMobile ? "0px" : "15%",
                                }}
                              >
                                {/* {con?.status === "LEADING" && <img src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/up-arrow.png" width="20px" height="20px"></img>} {con?.winner === "Result Awaited" ? "-" :  con?.winner?.replace(/&apos;/g, "")} */}
                                {con?.status_logo && (
                                  <div>
                                    <img
                                      src={con?.status_logo}
                                      style={{
                                        height: "18px",

                                        width: "18px",
                                      }}
                                    ></img>
                                  </div>
                                )}
                                <div>
                                  {con?.candidate_name?.replace(
                                    /&apos;/g,
                                    ""
                                  ) || con?.name.replace(/&apos;/g, "")}
                                </div>{" "}
                              </div>
                            </a>
                          )
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              gap: "5px",
                              justifyContent: isMobile
                                ? "flex-start "
                                : "center",
                              flexDirection: isMobile ? "column" : "row",
                              alignItems: "center",
                              // paddingLeft: isMobile ? "0px" : "20%",
                            }}
                          >
                            {/* {con?.status === "LEADING" && <img src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/up-arrow.png" width="20px" height="20px"></img>} {con?.winner === "Result Awaited" ? "-" :  con?.winner?.replace(/&apos;/g, "")} */}
                            {con?.status_logo && (
                              <div>
                                <img
                                  src={con?.status_logo}
                                  style={{
                                    height: "18px",

                                    width: "18px",
                                  }}
                                ></img>
                              </div>
                            )}
                            <div>
                              {con?.candidate_name?.replace(/&apos;/g, "") ||
                                con?.name.replace(/&apos;/g, "")}
                            </div>{" "}
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegionalsElectionResultsComponent;
